import { put, call } from 'redux-saga/effects';

import { callHttp } from '../utils/api';
import {
  customersReceived,
  handleError,
  setLiability,
  setTranslations,
  setPaymentUserInfo,
  notificationsReceived,
  setProfileInfo,
  setLanguage
} from '../actions';

import { GET_CUSTOMERS } from '../constants/graphql/customers';
import client from '../config/graphql';

import { selectBrowserLanguage } from './translations';

export function* getCustomers() {
  try {
    yield call(selectBrowserLanguage, { withTranslations: false });
    const response = yield callHttp(client.query, { query: GET_CUSTOMERS });
    const data = response.data;
    if (data.customers) {
      const customers = data.customers;
      yield put(customersReceived(customers));
      yield put(setLanguage(customers[0].language));
      yield put(
        setTranslations({
          translations: customers[0].liabilities[0].notes.notes_list
        })
      );
      yield put(setLiability(customers[0].liabilities[0]));
      yield put(setPaymentUserInfo(customers[0].liabilities[0]));
      yield put(setProfileInfo(customers[0]));
      yield put(notificationsReceived(customers[0].liabilities[0].serviceLog));
    } else {
      throw new Error(response.errors.message);
    }
  } catch (err) {
    yield put(handleError(err));
  }
}
